import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const INotebookKeymapService = ( createDecorator('notebookKeymapService'));
export { INotebookKeymapService };
